
























































import LINK_LIST from "@/general/assets/data/link";
import globals from "@/general/store/modules/globals";

export default {
  data() {
    return {
      snsGroup: [
        {
          id: 1,
          image: "/assets/img/logo_twitter01.png",
          alt: "Twitter",
          linkpath: "top/sns_twitter",
          text: "人気公演のチケット情報等をタイムリーにお届け"
        },
        {
          id: 2,
          image: "/assets/img/logo_facebook01.png",
          alt: "Facebook",
          linkpath: "top/sns_facebook",
          text: "無料セミナー情報など、社会人に嬉しい情報をご紹介"
        },
        {
          id: 3,
          image: "/assets/img/logo_instagram01.png",
          alt: "Instagram",
          linkpath: "top/sns_instagram",
          text: "社会人に役立つライフハック術を配信中"
        },
        {
          id: 4,
          image: "/assets/img/logo_tiktok01.png",
          alt: "Tiktok",
          linkpath: "top/sns_tiktok",
          text: "お得な情報やサービスなどをショート動画でご紹介"
        },
        {
          id: 5,
          image: "/assets/img/logo_youtube01.png",
          alt: "YouTube",
          linkpath: "top/sns_youtube",
          text: "キャンペーンや利用方法などを動画でご案内"
        }
      ],
      thumbnailStyle: "c-thumbnail__image-vertical"
    };
  },
  methods: {
    isSp(): boolean {
      return globals.isLargeBreakpointWidthOfSp;
    },
    postingLink(
      linkpath: string
    ): {
      title: any;
      url: any;
      target: string;
    } {
      const responsiveType = this.isSp() ? "SP" : "PC";
      const str = linkpath.split("/");
      // 遷移先リンク取得
      const linkData = LINK_LIST as any;
      const text_link = linkData[str[0]][str[1]][responsiveType];
      return {
        title: linkData[str[0]][str[1]].title,
        url: text_link,
        target: linkData[str[0]][str[1]].target_brank ? "_blank" : "_self"
      };
    }
  }
};
